import { render, staticRenderFns } from "./SideNavi.vue?vue&type=template&id=05677faf"
import script from "./SideNavi.vue?vue&type=script&lang=js"
export * from "./SideNavi.vue?vue&type=script&lang=js"
import style0 from "./SideNavi.vue?vue&type=style&index=0&id=05677faf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports